import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardHeader,
  ListItem,
  ListItemIcon,
  Divider,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  CardContent,
  CircularProgress,
} from "@material-ui/core";
import { invoiceStatuses } from "../Mappings";
import { makeStyles } from "@material-ui/core/styles";
import TruckIcon from "@material-ui/icons/LocalShipping";
import { UserDataContext } from "../Contexts/UserDataContext";
import { getWeekDates } from "../GlobalFunctions";
import Axios from "axios";

const useStyles = makeStyles((theme) => ({
  noPadding: {
    padding: theme.spacing(0),
  },
  extraPadding: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  loadParent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  loadChild: {},
}));

const InvoiceStatusCard = () => {
  const { userData, setUserData } = useContext(UserDataContext);
  const classes = useStyles();
  const history = useHistory();
  const weeks = [0, 1, 2, 3, 4];
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const sendRequests = async () => {
      try {
        setLoading(true);
        console.log("fetch invoice states");

        const weeks = [0, 1, 2, 3, 4];

        const reqArray = userData.trucks.reduce((acc, truckObj) => {
          const { truckId } = truckObj;
          const weeklyStatuses = weeks.map((week) => {
            const { startDate, endDate } = getWeekDates(week);
            return {
              driverId: truckId,
              // startDate: startIso,
              // endDate: endIso,
              startDate: startDate.toISOString(),
              endDate: endDate.toISOString(),
              week: week,
            };
          });
          return [...acc, ...weeklyStatuses];
        }, []);

        const request = {
          method: "POST",
          url: `/invoices/getStates`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${userData.token}`,
          },
          data: reqArray,
        };

        const res = await Axios(request);

        const statusObj = res.data.reduce(
          (acc, cur) => ({
            ...acc,
            [cur.driverId]: {
              ...acc[cur.driverId],
              [cur.week]: cur.invoiceState,
            },
          }),
          {}
        );

        console.log("updating userData from DpcStatusCard");
        setUserData({ ...userData, invoiceStatuses: statusObj });
      } catch (err) {
        console.log(err);
        throw err;
      } finally {
        setLoading(false);
      }
    };

    if (!userData.invoiceStatuses) {
      sendRequests();
    }
  }, []);

  return (
    <Card>
      <CardHeader title="Invoice Status" />
      <Divider />
      {!loading && (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.noPadding}>
                <Typography
                  variant="subtitle1"
                  className={classes.extraPadding}
                >
                  Truck ID
                </Typography>
              </TableCell>
              <TableCell className={classes.noPadding}>
                <Typography
                  variant="subtitle1"
                  className={classes.extraPadding}
                >
                  Trading Name
                </Typography>
              </TableCell>
              <TableCell className={classes.noPadding}>
                <Typography
                  variant="subtitle1"
                  className={classes.extraPadding}
                >
                  Week -4
                </Typography>
              </TableCell>
              <TableCell className={classes.noPadding}>
                <Typography
                  variant="subtitle1"
                  className={classes.extraPadding}
                >
                  Week -3
                </Typography>
              </TableCell>
              <TableCell className={classes.noPadding}>
                <Typography
                  variant="subtitle1"
                  className={classes.extraPadding}
                >
                  Week -2
                </Typography>
              </TableCell>
              <TableCell className={classes.noPadding}>
                <Typography
                  variant="subtitle1"
                  className={classes.extraPadding}
                >
                  Week -1
                </Typography>
              </TableCell>
              <TableCell className={classes.noPadding}>
                <Typography
                  variant="subtitle1"
                  className={classes.extraPadding}
                >
                  Current Week
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {userData.trucks.map(({ truckId, tradingName }, idx) => (
              <TableRow key={`${truckId}-${tradingName}-${idx}`}>
                <TableCell className={classes.noPadding}>
                  <ListItem className={classes.extraPadding}>
                    <ListItemIcon>
                      <TruckIcon />
                    </ListItemIcon>
                    #{truckId}
                  </ListItem>
                </TableCell>
                <TableCell className={classes.noPadding}>
                  <Typography className={classes.extraPadding}>
                    {tradingName}
                  </Typography>
                </TableCell>
                {[4, 3, 2, 1, 0].map((week) => (
                  <TableCell
                    className={classes.noPadding}
                    key={`${truckId}-${week}`}
                  >
                    <ListItem
                      button
                      className={classes.extraPadding}
                      onClick={() => {
                        history.push(
                          `/${userData.userName}/trucks/${truckId}/weeks/${week}`
                        );
                      }}
                      disabled={
                        userData.invoiceStatuses?.[truckId]?.[week] ===
                        invoiceStatuses.na
                      }
                    >
                      {invoiceStatuses[
                        userData.invoiceStatuses?.[truckId]?.[week]
                      ] || ""}
                    </ListItem>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      {loading && (
        <CardContent className={classes.loadParent}>
          <CircularProgress size={120} />
        </CardContent>
      )}
    </Card>
  );
};

export default InvoiceStatusCard;

/*
{userData.trucks.map((truckObj) => (
  <TableRow key={truckObj.truckId}>
    <TableCell className={classes.noPadding}>
      <ListItem className={classes.extraPadding}>
        <ListItemIcon>
          <TruckIcon />
        </ListItemIcon>
        #{truckObj.truckId}
      </ListItem>
    </TableCell>
    {[4, 3, 2, 1, 0].map((week) => {
      return (
        <TableCell
          className={classes.noPadding}
          key={`${truckObj.truckId}-${week}`}
        >
          <ListItem
            button
            className={classes.extraPadding}
            onClick={() => {
              history.push(
                `/${userData.userName}/trucks/${truckObj.truckId}/weeks/${week}`
              );
            }}
          >
            {invoiceStatuses[
              userData.invoiceStatuses[truckObj.truckId]?.[week]
            ] || ""}
          </ListItem>
        </TableCell>
      );
    })}
  </TableRow>
))}
*/

// setLoading(true);
// console.log("fetch invoice states");

// const weeks = [0, 1, 2, 3, 4];

// const reqArray = userData.trucks.reduce((acc, truckObj) => {
//   const { truckId } = truckObj;
//   const weeklyStatuses = weeks.map((week) => {
//     const { startDate, endDate } = getWeekDates(week);
//     return {
//       driverId: truckId,
//       startDate: startDate.toISOString(),
//       endDate: endDate.toISOString(),
//       week: week,
//     };
//   });
//   return [...acc, ...weeklyStatuses];
// }, []);

// const request = {
//   method: "POST",
//   url: `/invoices/getStates`,
//   headers: {
//     "Content-Type": "application/json",
//     Authorization: `bearer ${userData.token}`,
//   },
//   data: reqArray,
// };

// const res = await Axios(request);

// const statusObj = res.data.reduce(
//   (acc, cur) => ({
//     ...acc,
//     [cur.driverId]: {
//       ...acc[cur.driverId],
//       [cur.week]: cur.invoiceState,
//     },
//   }),
//   {}
// );

// console.log("updating userData from DpcStatusCard");
// setLoading(false);
// setUserData({ ...userData, invoiceStatuses: statusObj });

// ---------------------------------------------------------

// const [fetch, setFetch] = useState(false);

// const openReqLimit = 5;
// const [openReqCount, setOpenReqCount] = useState(0);

// console.log("invoice status card render");

// // build the array of request objects

// const launchRequest = async (requestObj) => {
//   setOpenReqCount(openReqCount + 1);
//   const res = await Axios(requestObj);
//   const { driverId, week, invoiceState } = res.data;
//   setUserData({
//     ...userData,
//     invoiceStatuses: {
//       ...userData.invoiceStatuses,
//       [driverId]: {
//         ...userData?.invoiceStatuses?.[driverId],
//         [week]: invoiceState,
//       },
//     },
//   });
//   setOpenReqCount(openReqCount - 1);
// };

// useEffect(() => {
//   // initially launch the first request
//   // if (!userData.invoiceStatuses) {
//   //   while (openReqCount < openReqLimit && reqArray.length > 0) {
//   //     launchRequest(reqArray.shift());
//   //   }
//   // }
//   if (!userData.invoiceStatuses) {
//     console.log("setFetch");
//     setFetch(true);
//     // launchRequest(reqArray.shift());
//   }
// }, []);

// useEffect(() => {
//   if (fetch) {
//     // launch more requests to keep the open req count at the limit
//     if (reqArray.length > 0 && openReqCount < openReqLimit) {
//       // if there are more requests to send
//       launchRequest(reqArray.shift());
//     }

//     // else if (openReqCount === 0) {
//     //   // if no open requests
//     //   setLoading(false);
//     // }
//   }
// }, [fetch, openReqCount]);

// useEffect(() => {
//   const launchAll = async () => {
//     setLoading(true);
//     const reqArray = userData.trucks.map((truckObj) => {
//       return {
//         method: "POST",
//         url: `/invoices/getStates`,
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `bearer ${userData.token}`,
//         },
//         data: weeks.map((week) => {
//           const { startDate, endDate } = getWeekDates(week);
//           return {
//             driverId: truckObj.truckId,
//             startDate: startDate.toISOString(),
//             endDate: endDate.toISOString(),
//             week: week,
//           };
//         }),
//       };
//     });

//     const responses = await Axios.all(reqArray)

//     const statusObj = res.data.reduce(
//       (acc, cur) => ({
//         ...acc,
//         [cur.driverId]: {
//           ...acc[cur.driverId],
//           [cur.week]: cur.invoiceState,
//         },
//       }),
//       {}
//     );
//     setUserData({
//       ...userData,
//       invoiceStatuses: { ...userData.invoiceStatuses, ...statusObj },
//     });

//     setLoading(false);
//   };

//   if (!userData.invoiceStatuses) {
//     launchAll();
//   }
// }, []);
